import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { RowMenuCellLocalStoreService } from './row-menu-cell-local-store.service';
import * as locationListActions from '../../../location-list/state/location-list-actions';
import { Store } from '@ngrx/store';
import { MarkerLocation } from '../../../map/map-utils';
import { RowMenuComponent } from '../../row-menu/row-menu.component';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { GtagEventDirective } from '../../../../../core/gx-gtag/gtag-event.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass, NgTemplateOutlet, NgOptimizedImage } from '@angular/common';
import { LetDirective } from '@ngrx/component';

export interface RowMenuViewModel {
  markerLocation: MarkerLocation,
  isCvOn: boolean
}

@Component({
    selector: 'app-row-menu-cell',
    templateUrl: './row-menu-cell.component.html',
    styleUrls: ['./row-menu-cell.component.scss'],
    providers: [RowMenuCellLocalStoreService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [LetDirective, NgClass, MatTooltip, GtagEventDirective, NgTemplateOutlet, MatIconButton, MatMenuTrigger, MatIcon, MatDivider, NgOptimizedImage, RowMenuComponent]
})
export class RowMenuCellComponent extends AgCellRendererComponent {

  viewModel$ = this.localStore.viewModel$;
  constructor(protected localStore: RowMenuCellLocalStoreService,
              private store: Store) {
    super(localStore);
  }

  /**
   * Dispatcher
   * @param rowMenuViewModel
   */
  onMarkerSvgClick(rowMenuViewModel: RowMenuViewModel) {
    if (rowMenuViewModel.markerLocation && !rowMenuViewModel.isCvOn) {
      this.store.dispatch(locationListActions.markerSvgClicked({ location: rowMenuViewModel.markerLocation.location }));
    }
  }

}
